import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter
} from '@angular/core';
import * as zxcvbn from 'zxcvbn';

@Component({
  selector: 'fl-strength-meter',
  templateUrl: './strength-meter.component.html',
  styleUrls: ['./strength-meter.component.css']
})
export class StrengthMeterComponent implements OnInit, OnChanges {
  @Input() password = '';

  @Output() strength = new EventEmitter();

  passwordStrength = 0;

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    const change = changes['password'];
    if (change) {
      this.getStrength(change.currentValue);
    }
  }

  getStrength(password) {
    const estimation = zxcvbn(password || '');
    this.passwordStrength = estimation.score;
    this.strength.emit({
      strength: this.passwordStrength
    });
  }

  getClass() {
    return `level-${this.passwordStrength}`;
  }
}
